import { Box, Divider, Paper, Typography, useTheme } from '@material-ui/core';
import usePrevious from 'helpers/usePrevious';
import React, { useCallback, useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import Select from 'react-select';
import { callApiGetListOfGrades } from 'redux/saga/mam-non/info/grade/getListOfGrades';
import { callApiGetListOfThuDauNam } from 'redux/saga/mam-non/info/thu-dau-nam/getListOfThuDauNam';
import { academic_year__get_list } from '../actions';
import AddIcon from '@material-ui/icons/Add';
import ThuDauNamList from './ThuDauNamList';
import ThuDauNamDialog from './ThuDauNamDialog';
import { customSelectStyles } from 'config/constants/reactSelectConstant';

const defaultThuDauNam = {
    name: '',
    amount: '',
};

function MamNonThuDauNamPage() {
    const theme = useTheme();
    const dispatch = useDispatch();

    const [grades, setGrades] = useState([]);
    const [thuDauNams, setThuDauNams] = useState(null);
    const [thuDauNam, setThuDauNam] = useState(null);
    const [open, setOpen] = useState(false);
    const { control, errors, setValue, getValues, trigger, watch } = useForm();
    const authenticationReducer = useSelector((state) => state.authenticationReducer);
    const commonReducer = useSelector((state) => state.commonReducer);

    const watches = watch();
    const values = getValues();
    const prevValues = usePrevious(values);

    useEffect(() => {
        dispatch(academic_year__get_list());
    }, [dispatch]);

    const getListThuDauNam = useCallback((gradeId) => {
        setThuDauNams(null);
        callApiGetListOfThuDauNam(gradeId).then((res) => {
            setThuDauNams(res.data);
        });
    }, []);

    useEffect(() => {
        const isDiff = JSON.stringify(values) !== JSON.stringify(prevValues);
        if (isDiff && values.grade && values.grade.id) {
            getListThuDauNam(values.grade.id);
        }
    }, [values, prevValues, watches, getListThuDauNam]);

    const academicYearsOptions = commonReducer.academicYears
        ? commonReducer.academicYears.map((item) => {
              return { value: item.name, label: item.name };
          })
        : [];

    const onAcademicYearChange = (selectedOption) => {
        setValue('grade', '');
        if (authenticationReducer.userInfo && authenticationReducer.userInfo.congDoanId) {
            callApiGetListOfGrades({ params: { congdoanId: authenticationReducer.userInfo.congDoanId, academicYear: selectedOption.value } })
                .then((res) => {
                    setGrades(res.data);
                })
                .catch((error) => {
                    console.warn(error);
                });
        }
    };

    const onGradeChange = (selectedOption) => {
        setValue('grade', selectedOption.value);
        trigger('grade');
    };

    const openDialog = () => {
        setOpen(true);
    };

    const closeDialog = () => {
        setOpen(false);
    };

    const addThuDauNam = () => {
        setThuDauNam(defaultThuDauNam);
        openDialog();
    };

    const onAddThuDauNamSuccess = (data) => {
        const newThuDauNams = [...thuDauNams];
        newThuDauNams.push(data);
        setThuDauNams(newThuDauNams);
        // setStudent(null);
        setThuDauNam(defaultThuDauNam);
    };

    const onEditThuDauNamSuccess = (data, index) => {
        const newThuDauNams = [...thuDauNams];
        newThuDauNams[index] = data;
        setThuDauNams(newThuDauNams);
    };

    const onDeleteSuccess = (index) => {
        const newThuDauNams = [...thuDauNams];
        newThuDauNams.splice(index, 1);
        setThuDauNams(newThuDauNams);
    };

    return (
        <>
            <Paper elevation={3}>
                <Box p={theme.spacing(0, 3)}>
                    <Typography variant="h6">Thu đầu năm</Typography>
                </Box>
                <Divider></Divider>
                <Box p={theme.spacing(1, 1)}>
                    <form>
                        <div className="row m-0">
                            <div className="col-md-3 pr-0">
                                <div className="row mr-0">
                                    <label className="mb-0 col-md-4 fmi-label pr-0" htmlFor="academicYear">
                                        Năm học:
                                    </label>
                                    <div className="col-md-8 p-0">
                                        <Select
                                            options={academicYearsOptions}
                                            id="academicYear"
                                            onChange={onAcademicYearChange}
                                            classNamePrefix="fmi-react-select"
                                            styles={customSelectStyles}
                                        ></Select>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className="row mr-0">
                                    <label className="mb-0 col-md-4 fmi-label">Khối:</label>
                                    <div className="col-md-8 p-0">
                                        <Controller
                                            name="grade"
                                            control={control}
                                            defaultValue=""
                                            rules={{
                                                required: {
                                                    value: true,
                                                    message: 'Vui lòng nhập khối để lấy danh sách dự thu!',
                                                },
                                            }}
                                            render={({ value }) => {
                                                return (
                                                    <Select
                                                        onChange={onGradeChange}
                                                        options={grades.map((item) => {
                                                            return { value: item, label: item.name };
                                                        })}
                                                        value={value !== '' ? value.label : ''}
                                                        classNamePrefix="fmi-react-select"
                                                        styles={customSelectStyles}
                                                    />
                                                );
                                            }}
                                        />
                                        {errors.clazz && <span className="text-danger">{errors.clazz.message}</span>}
                                    </div>
                                </div>
                            </div>
                            {values.grade && values.grade.id && (
                                <>
                                    <div className="col-md-3"></div>
                                    <div className="col-md-3">
                                        <div className="row mr-0 d-flex justify-content-end">
                                            <div className="col-md-12 p-0 d-flex justify-content-end">
                                                <button type="button" className="export-button btn btn-primary fmi-toolbar-button" onClick={addThuDauNam} title="Thêm thu đầu năm">
                                                    <AddIcon />
                                                    Thêm thu đầu năm
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            )}
                        </div>
                    </form>
                </Box>
            </Paper>
            {thuDauNams && <ThuDauNamList thuDauNams={thuDauNams} onEditSuccess={onEditThuDauNamSuccess} onDeleteSuccess={onDeleteSuccess} />}
            {thuDauNam && <ThuDauNamDialog thuDauNam={thuDauNam} open={open} closeDialog={closeDialog} gradeId={values.grade.id} onSuccess={onAddThuDauNamSuccess} />}
        </>
    );
}

export default MamNonThuDauNamPage;
